import "core-js/modules/es.array.map.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.concat.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import merge from "lodash/merge";
import { formatAMPM, formatDate, parseDate } from "@dp/common";
import moment from "moment-timezone";

var Times = /*#__PURE__*/function () {
  function Times(config, axios) {
    _classCallCheck(this, Times);

    _defineProperty(this, "axios", void 0);

    _defineProperty(this, "config", void 0);

    this.axios = axios;
    this.config = config;
  }

  _createClass(Times, [{
    key: "setOrderRestaurantAndPickupTime",
    value: function () {
      var _setOrderRestaurantAndPickupTime = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(restaurantId, requestedPickupDateTime) {
        var orderFlow,
            togoMenuFlow,
            asapSelected,
            commonQueryParams,
            locale,
            payload,
            requestedPickupDate,
            requestedPickupTime,
            response,
            data,
            formExceptions,
            status,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                orderFlow = _args.length > 2 && _args[2] !== undefined ? _args[2] : "togo-pickup-order";
                togoMenuFlow = _args.length > 3 && _args[3] !== undefined ? _args[3] : false;
                asapSelected = _args.length > 4 && _args[4] !== undefined ? _args[4] : false;
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                payload = {
                  restaurantId: restaurantId,
                  togoMenuFlow: togoMenuFlow,
                  asapSelected: asapSelected,
                  orderFlow: orderFlow,
                  locale: locale
                };

                if (requestedPickupDateTime) {
                  requestedPickupDate = formatDate(requestedPickupDateTime);
                  requestedPickupTime = formatAMPM(requestedPickupDateTime);
                  payload.requestedPickupDate = requestedPickupDate;
                  payload.requestedPickupTime = requestedPickupTime;
                }

                _context.next = 9;
                return this.axios.post(this.config.postfix.LOCATION_TIME, payload, {
                  headers: {
                    "x-retry-on-timeout": true
                  }
                });

              case 9:
                response = _context.sent;
                data = response.data;
                formExceptions = data === null || data === void 0 ? void 0 : data.formExceptions;
                status = data === null || data === void 0 ? void 0 : data.status;

                if (!(formExceptions || status !== "success")) {
                  _context.next = 15;
                  break;
                }

                throw data;

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function setOrderRestaurantAndPickupTime(_x, _x2) {
        return _setOrderRestaurantAndPickupTime.apply(this, arguments);
      }

      return setOrderRestaurantAndPickupTime;
    }()
  }, {
    key: "setOrderPickupTime",
    value: function () {
      var _setOrderPickupTime = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(requestedPickupDateTime) {
        var togoMenuFlow,
            asapSelected,
            removalCommerceIds,
            validateCartItems,
            commonQueryParams,
            locale,
            payload,
            requestedPickupDate,
            requestedPickupTime,
            response,
            _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                togoMenuFlow = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : false;
                asapSelected = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : false;
                removalCommerceIds = _args2.length > 3 ? _args2[3] : undefined;
                validateCartItems = _args2.length > 4 && _args2[4] !== undefined ? _args2[4] : true;
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                payload = {
                  togoMenuFlow: togoMenuFlow,
                  asapSelected: asapSelected,
                  locale: locale,
                  validateCartItems: validateCartItems
                };

                if (requestedPickupDateTime) {
                  requestedPickupDate = formatDate(requestedPickupDateTime);
                  requestedPickupTime = formatAMPM(requestedPickupDateTime);
                  payload.requestedPickupDate = requestedPickupDate;
                  payload.requestedPickupTime = requestedPickupTime;
                }

                if (removalCommerceIds) {
                  payload.removalCommerceIds = removalCommerceIds;
                }

                _context2.next = 11;
                return this.axios.post(this.config.postfix.SETPICKUP_TIME, payload, {
                  headers: {
                    "x-retry-on-timeout": true
                  }
                });

              case 11:
                response = _context2.sent;
                return _context2.abrupt("return", response.data);

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function setOrderPickupTime(_x3) {
        return _setOrderPickupTime.apply(this, arguments);
      }

      return setOrderPickupTime;
    }()
  }, {
    key: "getPickupTimes",
    value: function () {
      var _getPickupTimes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(restaurantId) {
        var orderType,
            pickupDate,
            realTime,
            capacityEnabled,
            asapSelected,
            commonQueryParams,
            locale,
            response,
            responseData,
            _responseData$restaur,
            pickupDateStr,
            curbSideHoursStr,
            _args3 = arguments;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                orderType = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : 0;
                pickupDate = _args3.length > 2 ? _args3[2] : undefined;
                realTime = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : false;
                capacityEnabled = _args3.length > 4 && _args3[4] !== undefined ? _args3[4] : true;
                asapSelected = _args3.length > 5 && _args3[5] !== undefined ? _args3[5] : false;
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                _context3.next = 9;
                return this.axios.get(this.config.postfix.PICKUP_TIMES, {
                  params: realTime ? {
                    restaurantId: restaurantId,
                    source: "DASH",
                    orderType: "".concat(orderType),
                    pickupDate: formatDate(pickupDate),
                    capacityEnabled: capacityEnabled,
                    asapSelected: asapSelected,
                    locale: locale
                  } : {
                    restaurantId: restaurantId,
                    orderType: "".concat(orderType),
                    pickupDate: formatDate(pickupDate),
                    capacityEnabled: capacityEnabled,
                    asapSelected: asapSelected,
                    locale: locale
                  }
                });

              case 9:
                response = _context3.sent;
                responseData = response === null || response === void 0 ? void 0 : response.data;

                if (!responseData.successResponse) {
                  _context3.next = 18;
                  break;
                }

                pickupDateStr = formatDate(pickupDate);
                curbSideHoursStr = responseData.curbSideHours;
                delete responseData.curbSideHours;
                return _context3.abrupt("return", merge(responseData, {
                  successResponse: {
                    currentTime: responseData.successResponse.currentTime ? {
                      dateTime: responseData.successResponse.currentTime.time ? moment(responseData.successResponse.currentTime.time).toDate() : null
                    } : null,
                    capacitySlots: responseData.successResponse.capacitySlots ? {
                      availableSlots: responseData.successResponse.capacitySlots.availableSlots ? responseData.successResponse.capacitySlots.availableSlots.map(function (slot) {
                        return {
                          endDateTime: slot.endTime ? moment(responseData.successResponse.capacitySlots.capacityDate + " " + slot.endTime).toDate() : null,
                          lowInventory: slot.lowInventory,
                          startDateTime: slot.startTime ? moment(responseData.successResponse.capacitySlots.capacityDate + " " + slot.startTime).toDate() : null
                        };
                      }) : null,
                      capacityDateTime: responseData.successResponse.capacitySlots.capacityDate ? moment(responseData.successResponse.capacitySlots.capacityDate).toDate() : null,
                      interval: responseData.successResponse.capacitySlots.interval,
                      unavailableSlots: responseData.successResponse.capacitySlots.unavailableSlots ? responseData.successResponse.capacitySlots.unavailableSlots.map(function (slot) {
                        return {
                          startDateTime: slot.startTime ? moment(responseData.successResponse.capacitySlots.capacityDate + " " + slot.startTime).toDate() : null,
                          endDateTime: slot.endTime ? moment(responseData.successResponse.capacitySlots.capacityDate + " " + slot.endTime).toDate() : null,
                          lowInventory: slot.lowInventory
                        };
                      }) : null
                    } : null
                  },
                  times: responseData.times ? {
                    lunch: responseData.times.lunch ? {
                      startDateTime: responseData.times.lunch.startTime ? moment(pickupDateStr + " " + responseData.times.lunch.startTime, "L HH:mm").toDate() : null,
                      endDateTime: responseData.times.lunch.endTime ? moment(pickupDateStr + " " + responseData.times.lunch.endTime, "L HH:mm").toDate() : null
                    } : null,
                    dinner: responseData.times.dinner ? {
                      startDateTime: responseData.times.dinner.startTime ? moment(pickupDateStr + " " + responseData.times.dinner.startTime, "L HH:mm").toDate() : null,
                      endDateTime: responseData.times.dinner.endTime ? moment(pickupDateStr + " " + responseData.times.dinner.endTime, "L HH:mm").toDate() : null
                    } : null
                  } : null,
                  showPayOnline: responseData.showPayOnline + "" === "true" ? true : false,
                  restaurantClosed: responseData.restaurantClosed + "" === "true" ? true : false,
                  restPermClosedDate: responseData.restPermClosedDate ? parseDate(responseData.restPermClosedDate) : null,
                  interval: responseData.interval ? parseInt(responseData.interval + "") : null,
                  restCurrenthoursForDeliveryDate: responseData.restCurrenthoursForDeliveryDate ? parseInt(responseData.restCurrenthoursForDeliveryDate + "") : null,
                  requestedDate: responseData.requestedDate ? parseDate(responseData.requestedDate) : null,
                  restaurantAvailableDate: responseData.restaurantAvailableDate ? parseDate(responseData.restaurantAvailableDate) : null,
                  closedToday: responseData.closedToday + "" === "true" ? true : false,
                  restaurantHolidayDates: responseData.restaurantHolidays ? (_responseData$restaur = responseData.restaurantHolidays.split("@")) === null || _responseData$restaur === void 0 ? void 0 : _responseData$restaur.map(function (dateStr) {
                    try {
                      var parts = dateStr.split("/");
                      return moment("".concat(parts[2], "-").concat(parts[1], "-").concat(parts[0])).toDate();
                    } catch (e) {// NOOP
                    }

                    return null;
                  }) : null,
                  curbSideHours: curbSideHoursStr ? curbSideHoursStr.split("#") : curbSideHoursStr
                }));

              case 18:
                return _context3.abrupt("return", responseData);

              case 19:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getPickupTimes(_x4) {
        return _getPickupTimes.apply(this, arguments);
      }

      return getPickupTimes;
    }()
  }, {
    key: "getCapacityTimeSlots",
    value: function () {
      var _getCapacityTimeSlots = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(restaurantId, pickupDate, orderType, nextAvailableSlot) {
        var commonQueryParams, locale, pickupDateStr, response;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                pickupDateStr = formatDate(pickupDate);
                _context4.next = 5;
                return this.axios.get(this.config.postfix.CAPACITY_TIMES_SLOTS, {
                  params: {
                    orderType: orderType,
                    nextAvailableSlot: nextAvailableSlot,
                    restaurantId: restaurantId,
                    pickupDate: pickupDateStr,
                    locale: locale
                  }
                });

              case 5:
                response = _context4.sent;
                return _context4.abrupt("return", response.data);

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getCapacityTimeSlots(_x5, _x6, _x7, _x8) {
        return _getCapacityTimeSlots.apply(this, arguments);
      }

      return getCapacityTimeSlots;
    }()
  }]);

  return Times;
}();

export { Times as default };